// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","textDefault":"#808080","container":"ZeGYFZae-XumKlXR5WjM0","link":"_367Qi2Cqsz3zWp5DE-oFGk","formWrapper":"_27Awfr6EevgEbNWzV6UlXe","title":"kF7fuEtPA6dDI4B4rJXGv","recover":"_3pV4s1vxIscQ64-4SSpnDq","buttons":"_1AoPk1Y2UeAxKiP-NCNS5p"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/LogIn/LogIn.mod.css
// module id = 597
// module chunks = 0